import offsetParent from './offset-parent';

var isBodyOffset = function isBodyOffset(element) {
  return offsetParent(element) === element.ownerDocument.body;
};

export default isBodyOffset;